import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || "";

/**
 * Google Analytics 4 tracker.
 * - Injects gtag.js once (on first mount) if GA_MEASUREMENT_ID is set
 * - Tracks SPA route changes as page_view events
 * Safe when ID is empty (renders nothing, injects nothing).
 */
const Analytics = () => {
    const { pathname, search } = useLocation();

    // Load gtag.js once
    useEffect(() => {
        if (!GA_MEASUREMENT_ID) return;
        if (window.gtag) return; // already loaded

        const script = document.createElement("script");
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
        document.head.appendChild(script);

        window.dataLayer = window.dataLayer || [];
        window.gtag = function () {
            window.dataLayer.push(arguments);
        };
        window.gtag("js", new Date());
        window.gtag("config", GA_MEASUREMENT_ID, {
            send_page_view: false, // we manually send on route change
            anonymize_ip: true,
        });
    }, []);

    // Track page views on route change
    useEffect(() => {
        if (!GA_MEASUREMENT_ID || !window.gtag) return;
        window.gtag("event", "page_view", {
            page_path: pathname + search,
            page_location: window.location.href,
            page_title: document.title,
        });
    }, [pathname, search]);

    return null;
};

/**
 * Helper to track custom events (form submissions, CTAs, etc.).
 * Usage: trackEvent('contact_form_submit', { subject: 'X' })
 */
export const trackEvent = (name, params = {}) => {
    if (typeof window !== "undefined" && window.gtag) {
        window.gtag("event", name, params);
    }
};

export default Analytics;
